import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

export default function InputTextEmail(props) {
  const [error, setError] = useState(false);
  const [email, setEmail] = useState(props.value || "");
  const toast = React.useRef(null); // Ref para o Toast

  // Função para validar o e-mail com expressão regular
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    setEmail(newValue); // Atualiza o valor do e-mail

    // Atualiza erro caso o e-mail não seja válido
    setError(newValue.length > 0 && !validateEmail(newValue));

    if (props.onChange) {
      props.onChange(event);
    }
  };

  const showErrorToast = () => {
    if (error) {
      toast.current.show({
        severity: "error",
        summary: "Erro",
        detail: "O Email informado é inválido! Verifique!",
        life: 3000, // Tempo de exibição da notificação
      });
    }
  };

  return (
    <div className="p-field">
      {/* Componente Toast para mostrar notificações */}
      <Toast ref={toast} />

      <InputText
        {...props}
        type="email"
        value={email}
        onChange={handleChange}
        className={error ? 'p-inputtext w-full mt-2 p-invalid' : 'p-inputtext w-full mt-2'}
        onBlur={showErrorToast} // Exibe o erro no blur
      />
      {error && (
        <small className="p-error">E-mail inválido</small> // Exibe a mensagem de erro abaixo do campo
      )}
    </div>
  );
}
